import { CUSTOMER_ACTIONS } from "./action";

// ----------------------------------------------------------------------

const customerInitialState = {
  data: [],
  customer: {},
  loading: false,
  pagination: {
    currentPage: 0,
    totalPages: 1,
    perPage: 1,
    total: 1,
  },
};

// eslint-disable-next-line default-param-last
export function customerReducer(state = customerInitialState, action) {
  switch (action.type) {
    case CUSTOMER_ACTIONS.SET_STATE:
      return { ...state, ...action.payload };
    default:
      return state;
  }
}
